import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import WelcomeMessagesQuery, {
	type WelcomeMessagesQuery$data,
	type WelcomeMessagesQuery$variables,
} from './__generated__/WelcomeMessagesQuery.graphql.ts';

export function preloadWelcomeMessages() {
	return query<WelcomeMessagesQuery$data, WelcomeMessagesQuery$variables>({
		query: WelcomeMessagesQuery,
	});
}
